
import * as dom from './../../modules/wpstg-dom-utils.js';

// Delay time in millisecond after which the request is send to check db connection
// This is to make sure we have not many ajax request even when they were not required i.e. while typing.
export const DELAY_TIME_DB_CHECK = 300;
export default class WpstgCloneEdit {
  constructor(
      workflowSelector = '#wpstg-workflow',
      dbCheckTriggerClass = '.wpstg-edit-clone-db-inputs',
      wpstgObject = wpstg,
      databaseCheckAction = 'wpstg_database_connect',
  ) {
    this.workflow = dom.qs(workflowSelector);
    this.dbCheckTriggerClass = dbCheckTriggerClass;
    this.wpstgObject = wpstgObject;
    this.databaseCheckAction = databaseCheckAction;
    this.dbCheckTimer = null;
    this.abortDbCheckController = null;
    this.dbCheckCallStatus = false;
    this.notyf = new Notyf({
      duration: 10000,
      position: {
        x: 'center',
        y: 'bottom',
      },
      dismissible: true,
      types: [
        {
          type: 'warning',
          background: 'orange',
          icon: false,
        },
      ],
    });
    this.init();
  }

  addEvents() {
    // early bail if workflow object not available.
    if (this.workflow === null) {
      return;
    }

    ['paste', 'input'].forEach( (evt) => {
      dom.addEvent(this.workflow, evt, this.dbCheckTriggerClass, () => {
        // abort previous database check call if it was running
        if (this.dbCheckCallStatus === true) {
          this.abortDbCheckController.abort();
          this.abortDbCheckController = null;
          this.dbCheckCallStatus = false;
        }

        // check for db connection after specific delay but reset the timer if these event occur again
        clearTimeout(this.dbCheckTimer);
        this.dbCheckTimer = setTimeout(() => {
          this.checkDatabase();
        }, DELAY_TIME_DB_CHECK);
      });
    });
  }

  init() {
    this.addEvents();
  }

  checkDatabase() {
    const idPrefix = '#wpstg-edit-clone-data-';
    const externalDBUser = dom.qs(idPrefix + 'database-user').value;
    const externalDBPassword = dom.qs(idPrefix + 'database-password').value;
    const externalDBDatabase = dom.qs(idPrefix + 'database-database').value;
    const externalDBHost = dom.qs(idPrefix + 'database-server').value;
    const externalDBPrefix = dom.qs(idPrefix + 'database-prefix').value;

    if (externalDBUser === '' && externalDBPassword === '' && externalDBDatabase === '' && externalDBPrefix === '') {
      dom.qs('#wpstg-save-clone-data').disabled = false;
      return;
    }

    this.abortDbCheckController = new AbortController();
    this.dbCheckCallStatus = true;

    fetch(this.wpstgObject.ajaxUrl, {
      method: 'POST',
      signal: this.abortDbCheckController.signal,
      credentials: 'same-origin',
      body: new URLSearchParams({
        action: this.databaseCheckAction,
        accessToken: this.wpstgObject.accessToken,
        nonce: this.wpstgObject.nonce,
        databaseUser: externalDBUser,
        databasePassword: externalDBPassword,
        databaseServer: externalDBHost,
        databaseDatabase: externalDBDatabase,
        databasePrefix: externalDBPrefix,
        databaseEnsurePrefixTableExist: true,
      }),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }).then((response) => {
      this.dbCheckCallStatus = false;
      if (response.ok) {
        return response.json();
      }

      return Promise.reject(response);
    }).then((data) => {
      // dismiss previous toasts
      this.notyf.dismissAll();
      // failed request
      if (false === data) {
        this.notyf.error(this.wpstgObject.i18n['dbConnectionFailed']);
        dom.qs('#wpstg-save-clone-data').disabled = true;
        return;
      }

      // failed db connection
      if ('undefined' !== typeof (data.errors) && data.errors && 'undefined' !== typeof (data.success) && data.success === 'false') {
        this.notyf.error(this.wpstgObject.i18n['dbConnectionFailed'] +'! <br/> Error: '+ data.errors);
        dom.qs('#wpstg-save-clone-data').disabled = true;
        return;
      }

      // prefix warning
      if ('undefined' !== typeof (data.errors) && data.errors && 'undefined' !== typeof (data.success) && data.success === 'true') {
        this.notyf.open({
          type: 'warning',
          message: 'Warning: ' + data.errors,
        });
        dom.qs('#wpstg-save-clone-data').disabled = true;
        return;
      }

      // db connection successful
      if ('undefined' !== typeof (data.success) && data.success) {
        this.notyf.success(this.wpstgObject.i18n['dbConnectionSuccess']);
        dom.qs('#wpstg-save-clone-data').disabled = false;
      }
    }).catch((error) => {
      this.dbCheckCallStatus = false;
      console.warn(this.wpstgObject.i18n['somethingWentWrong'], error);
      dom.qs('#wpstg-save-clone-data').disabled = true;
    });
  }
}
